import { useState } from "react";
import { Link } from "react-router-dom";
import CustomLabel from "../common/CustomLabel";
import LoadingAnimation from "../common/LoadingAnimation";
import ErrorModal from "../modals/ErrorModal";
import { useUserRegister } from "../hooks/useUserRegister";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
// import googleSignIn from "../../images/googleSignIn.svg";

const UserRegister = () => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    signUpDetails,
    errors,
    loading,
    signUpError,
    setSignUpError,
    handleDetailsChange,
    handleSignUp,
    isFormValid,
  } = useUserRegister();

  const clearError = () => {
    setSignUpError({ error: false, message: undefined });
  };

  // const handleGoogleSignIn = async () => {
  //   const url = `${process.env.REACT_APP_API_URL}/api/auth/google/login`;
  //   window.open(url, "_blank", "width=500,height=600");
  // };

  return (
    <div className="w-[calc(100%-32px)] xs:w-[calc(100%-80px)] sm:w-[530px] lg:w-[52vw] max-w-[700px] h-[74vh] bg-white rounded-[30px] flex flex-col items-center justify-center">
      <h1 className="font-extrabold text-2xl mb-4">Create Account</h1>

      <form
        onSubmit={handleSignUp}
        className="relative flex flex-col justify-center items-center w-[calc(100%-64px)] sm:w-[calc(100%-128px)] md:w-[calc(100%-256px)] text-gray-7 text-center"
      >
        <div className="flex flex-col mb-[20px] w-full gap-6">
          <CustomLabel
            labelTextClass="text-gray-7 px-4 font-semibold pl-2"
            labelWrapClass="text-left !gap-1"
            labelText="E-mail"
          >
            <input
              type="email"
              name="email"
              placeholder="Enter your e-mail"
              value={signUpDetails.email || ""}
              onChange={handleDetailsChange}
              className={`font-medium text-sm leading-4 text-gray-7 w-full border-[1.5px] pl-4 py-3 pr-[38px] rounded-[13px] outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-text ${
                errors.email ? "border-danger" : "border-gray-7"
              }`}
            />

            {errors.email && (
              <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
                {errors.email}
              </p>
            )}
          </CustomLabel>

          <CustomLabel
            labelTextClass="text-gray-7 px-4 font-semibold pl-2"
            labelWrapClass="text-left !gap-1"
            labelText="Password"
          >
            <div className="relative w-full">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter your password"
                value={signUpDetails.password || ""}
                onChange={handleDetailsChange}
                className={`font-medium text-sm leading-4 text-gray-7 w-full border-[1.5px] ${
                  errors.password ? "border-danger" : "border-gray-7"
                } pl-4 py-3 pr-[38px] rounded-[13px] outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-text`}
              />
              <button
                type="button"
                className="absolute inset-y-0 right-4 flex items-center text-gray-7"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? (
                  <span className="material-icons">
                    <FaEyeSlash size={20} className="text-dark-7" />
                  </span>
                ) : (
                  <span className="material-icons">
                    <FaEye size={20} className="text-dark-7" />
                  </span>
                )}
              </button>
            </div>

            {errors.password && (
              <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
                {errors.password}
              </p>
            )}
          </CustomLabel>
        </div>

        <div className="flex flex-col gap-6 w-[calc(100%-16px)]">
          <button
            type="submit"
            disabled={!isFormValid || loading}
            className="text-lg leading-[22px] font-extrabold w-full text-white bg-gray-7 disabled:bg-gray-3 py-3 rounded-[10px]"
          >
            {loading ? <LoadingAnimation /> : "Sign Up"}
          </button>
        </div>

        <div className="flex flex-col mt-3 w-full items-center">
          {/* <div className="flex items-center justify-center my-3 gap-3 w-full">
            <span className="flex-1 border-b border-[rgba(0, 0, 0, 0.2)"></span>
            or
            <span className="flex-1 border-b border-[rgba(0, 0, 0, 0.2)"></span>
          </div>

          <button
            type="button"
            onClick={handleGoogleSignIn}
            className="flex items-center justify-center gap-4 text-md font-medium w-full text-gray-7 border border-[#4285F4] py-3 rounded-[10px]"
          >
            <img src={googleSignIn} alt="google" /> Sign Up With Google
          </button> */}

          <p className="text-xs text-gray-500 mt-4 text-center px-4">
            By continuing, you agree to Unspokenn Terms of Service and
            acknowledge you have read our Privacy Policy.
          </p>
        </div>

        <div className="flex flex-col mt-6 items-center">
          <p className="text-sm text-gray-7">
            Already a member?{" "}
            <Link to="/login" className="underline font-semibold text-gray-7">
              Login
            </Link>
          </p>
        </div>

        {signUpError.error && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md z-50">
            <ErrorModal
              onAccept={clearError}
              onClose={clearError}
              errorDescription={
                signUpError.message ||
                "We encountered an error while signing you up, please try again."
              }
            />
          </div>
        )}
      </form>
    </div>
  );
};

export default UserRegister;
